/* global femcare */
 
femcare.tracking.analyticsEvents = {
    init () {
        const analyticsCookie = this.getCookie('AnalyticsEvents');
 
        if (analyticsCookie) {
            const analyticsEvents = JSON.parse(analyticsCookie);
 
            for (let index = 0; index < analyticsEvents.length; index++) {
                femcare.tracking.analytics.push(analyticsEvents[index]);
            }
 
            this.deleteCookie('AnalyticsEvents');
        }
 
        this.addClickToBuyIframeAnalyticsData();
    },
 
    deleteCookie (name) {
        document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
 
    getCookie (name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift();
        }
    },
    /**
     * Handles messages from an external click2buy iframe and push analytics data to the dataLayer.
     */
    addClickToBuyIframeAnalyticsData () {
        window.addEventListener('message', (event) => {
            if (event.origin !== 'https://widget.clic2buy.com') {
                return;
            }
 
            if (event.data && event.data.action === 'select_retail_outlet') {
 
                const productName = $('.product-main__name').text().trim();
                const ean = $('.product-main').data('ean');
 
                const retailer_ga4_data = {
                    retailer: event.data.retail_outlet.retailer_name,
                    single_item_id: ean,
                    single_item_name: productName
                };
 
                femcare.tracking.analytics.pushEvent('ga4_buy_now_go_to_retailer', retailer_ga4_data);
            }
        });
    }
};
